import { FaExclamation } from "react-icons/fa";

interface InfoBoxProps {
  children: React.ReactNode;
  type?: 'info' | 'warning';
  title?: string;
  className?: string;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ children, type = 'warning', title, className }) => {
  const typeClasses = {
    info: 'bg-primary-120 text-gray-800',
    warning: 'bg-primary-120 text-gray-800'
  };

  return (
    <div className={`p-3 md:p-4 rounded-md flex ${type === 'info' ? "flex-col items-start" : "flex-row items-center gap-2"} ${typeClasses[type]} ${className}`}>
      {type === 'warning' && (
        <span className="font-bold text-primary-600">
          <FaExclamation size={20} />
        </span>
      )}
      {type === 'info' && (
        <div className="font-bold">
          <h4>{title}</h4>
        </div>
      )}
      <div className={`text-xs sm:text-sm md:text-justify ${type === 'info' ? "font-medium leading-normal" : "font-semibold leading-relaxed"}`}>
        {children}
      </div>
    </div>
  );
};
